import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import Application from 'bundles/workspaces-app/app/Application';
import AuthenticationPage from 'bundles/workspaces-app/components/AuthenticationPage';
import NotFound from 'bundles/workspaces-app/components/NotFound';

const routes = (
  <Route path="/workspaces" component={Application}>
    <IndexRoute component={NotFound} />
    <Route path="authenticate/:workspaceId" component={AuthenticationPage} />
    <Route path="*" component={NotFound} />
  </Route>
);

export default routes;
